import SubMenu from "./SubMenu"
import { NeoComponents } from "@forcepoint/platform-utilityui"
import * as singleSpa from "single-spa"
import { APP_URL } from "@forcepoint/platform-coreui"
import { CaretIcon } from "./CaretIcon"
import { isAppActive } from "./Sidebar.utils"
import { MenuItemProps } from "./Sidebar.types"


const MenuItem = ({
  currentApplication,
  setOpenMenuCode,
  openMenuCode,
  activeAppCode
}: MenuItemProps) => {

  const isExternalApp = currentApplication.applicationType === "external"

  const handleMenuClick = (ev) => {
    if (openMenuCode === currentApplication?.applicationCode && currentApplication?.menus?.length > 0) {
      setOpenMenuCode(null)
    } else if (isExternalApp) {
      const applicationUrl = APP_URL.endsWith(".eu")
        ? currentApplication.iframeURL
        : currentApplication.applicationURL
      window.open(applicationUrl, "_blank")
    } else if (currentApplication?.menus?.length < 1) {
      singleSpa.navigateToUrl(currentApplication.applicationURL)
    } else {
      setOpenMenuCode(currentApplication?.applicationCode)
    }
    ev.stopPropagation()
  }

  return (
    <div className="menu-container">
      <div
        className="menu-item"
        onClick={handleMenuClick}
        onKeyDown={() => { }}
        data-testid={`menu-item-${currentApplication?.applicationName}`}
      >
        <div className="icon-app-name">
          {/* TODO: Remove NeoIcon and create a custom icon that works via a selection.json that will be stored in shell ui (works like neo icon) */}
          <NeoComponents.NeoIcon
            name={currentApplication?.productLogo || "applications"}
            size={16}
            fill={isAppActive(activeAppCode, currentApplication) ? "#00AF9A" : "#3D4E5C"}
          />
          <span
            className={`appName ${isAppActive(activeAppCode, currentApplication) ? "active-appName" : ""}`}
          >
            {currentApplication?.applicationName}
          </span>
          {isExternalApp && <img className="sidemenu-link-icon" data-dark-tip="Open in a new tab" data-always={true} src="/assets/images/linkIcon.svg" alt="open link in new tab" />}
        </div>
        {
          currentApplication?.menus?.length > 0 &&
          <CaretIcon isOpen={openMenuCode === currentApplication.applicationCode} />
        }
      </div>
      {currentApplication?.menus?.length > 0 && openMenuCode === currentApplication.applicationCode && (
        <SubMenu subMenus={currentApplication?.menus} currentApplication={currentApplication} />
      )}
    </div>
  )
}

export default MenuItem
